import { useEffect, useMemo } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { useOrderCountdownStore } from '@/store/orderCountdown'

const formatSeconds = (total: number) => {
  const mm = String(Math.floor(total / 60)).padStart(2, '0')
  const ss = String(total % 60).padStart(2, '0')
  return `${mm}:${ss}`
}

const OrderCountdownFloat: React.FC = () => {
  const navigate = useNavigate()
  const countdowns = useOrderCountdownStore((state) => state.countdowns)
  const tick = useOrderCountdownStore((state) => state.tick)

  useEffect(() => {
    const id = setInterval(() => tick(), 1000)
    return () => clearInterval(id)
  }, [tick])

  const items = useMemo(
    () => Object.values(countdowns).sort((a, b) => a.remainingSeconds - b.remainingSeconds),
    [countdowns],
  )

  if (items.length === 0) {
    return null
  }

  return (
    <div
      style={{
        position: 'fixed',
        right: 12,
        bottom: 120,
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        alignItems: 'flex-end',
      }}
    >
      {items.map((item) => (
        <div
          key={item.orderId}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            backgroundColor: '#fff',
            padding: '6px 10px',
            borderRadius: 999,
            boxShadow: '0 6px 16px rgba(0,0,0,0.18)',
            maxWidth: 260,
            cursor: 'pointer',
          }}
          onClick={() =>
            navigate({
              to: '/order/$orderId',
              params: { orderId: item.encodedOrderId || item.orderId },
            })
          }
        >
          <div
            style={{
              width: 54,
              height: 54,
              borderRadius: '50%',
              backgroundColor: item.remainingSeconds <= 300 ? '#ff4d4f' : '#1677ff',
              color: '#fff',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: 12,
              flexShrink: 0,
            }}
          >
            <div style={{ fontSize: 11 }}>倒计时</div>
            <div style={{ fontWeight: 600 }}>{formatSeconds(item.remainingSeconds)}</div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'right' }}>
            <span style={{ fontSize: 12, color: '#999' }}>
              {item.encodedOrderId || `订单${item.orderId}`}
            </span>
            <span
              style={{
                fontSize: 13,
                color: '#333',
                maxWidth: 150,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {item.courseName || '支付中'}
            </span>
          </div>
        </div>
      ))}
    </div>
  )
}

export default OrderCountdownFloat
